import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { Home } from '@library/store/homes/homes.interface';
import { PageLoaderFacade } from '@library/store/page-loader/page-loader.facade';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { HeaderService } from '@library/utils/services/header.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-home-view',
  templateUrl: './home-view.component.html',
  styleUrls: ['./home-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HomeViewComponent implements OnInit {
  home$ = this.homesFacade.currentHome$.pipe(isDefined());

  constructor(
    private readonly header: HeaderService,
    private readonly homesFacade: HomesFacade,
    private readonly pageLoaderFacade: PageLoaderFacade,
    private readonly titleService: Title,
    private readonly activatedRoute: ActivatedRoute,
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.pageLoaderFacade.handlePageLoader();
    const homeId = this.activatedRoute.snapshot.params.home_id;
    this.homesFacade.selectHome(homeId);
    const home = await firstValueFrom(this.home$);
    this.header.push({ title: home.name });
    this.titleService.setTitle('Home advanced settings');
  }

  /**
   * Prettify the timezone from store: Europe/Isle_Of_Man -> Europe, Isle Of Man
   * @param home Current home
   */
  getHomeTimezonePretty(home: Home): string {
    return home.place.timezone.replace(/\//g, ', ').replace(/_/g, ' ');
  }
}
